(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anu-seasonal-kits"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('anu-ready-kits'))customElements.define('anu-ready-kits',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();
  const track=this.querySelector('[data-kit-daily-track]'),cards=[...track.children],controls=this.querySelector('[data-kit-daily-controls]');
  if(cards.length<2)return;controls.hidden=false;
  const previous=this.querySelector('[data-kit-prev]'),next=this.querySelector('[data-kit-next]'),position=this.querySelector('[data-kit-position]');
  const update=()=>{const step=track.clientWidth+24;position.textContent=(Math.round(track.scrollLeft/step)+1)+' / '+cards.length;previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2};
  const move=direction=>track.scrollBy({left:direction*(track.clientWidth+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  const on=(element,event,fn)=>element.addEventListener(event,fn,{signal:this.abort.signal});
  on(previous,'click',()=>move(-1));on(next,'click',()=>move(1));on(track,'scroll',update);
  on(track,'keydown',event=>{if(event.target===track&&['ArrowRight','ArrowLeft'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});
  this.resize=new ResizeObserver(update);this.resize.observe(track);update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-discovery-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('px-discovery-rail')) {
 customElements.define('px-discovery-rail',class extends HTMLElement{
  connectedCallback(){
   if(this.dataset.ready)return;this.dataset.ready='true';
   const track=this.querySelector('[data-px-track]');
   const move=direction=>track.scrollBy({left:direction*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   this.querySelector('[data-px-prev]').addEventListener('click',()=>move(-1));
   this.querySelector('[data-px-next]').addEventListener('click',()=>move(1));
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-product-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('px-product-tabs')) {
 customElements.define('px-product-tabs', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.enhanced) return;
   this.tabs = Array.from(this.querySelectorAll('[data-px-tab]'));
   this.panels = Array.from(this.querySelectorAll('[data-px-panel]'));
   if (!this.tabs.length) return;
   this.dataset.enhanced = 'true';
   this.querySelector('.px-tab-list').setAttribute('role','tablist');
   this.tabs.forEach((tab,i) => {
    tab.setAttribute('role','tab');
    tab.setAttribute('aria-controls',this.panels[i].id);
    this.panels[i].setAttribute('role','tabpanel');
    this.panels[i].setAttribute('aria-labelledby',tab.id);
    this.panels[i].tabIndex = 0;
    tab.addEventListener('click',event => {event.preventDefault();this.select(i);});
    tab.addEventListener('keydown',event => {
     let target = i;
     if (event.key === 'ArrowRight') target = (i + 1) % this.tabs.length;
     else if (event.key === 'ArrowLeft') target = (i - 1 + this.tabs.length) % this.tabs.length;
     else if (event.key === 'Home') target = 0;
     else if (event.key === 'End') target = this.tabs.length - 1;
     else return;
     event.preventDefault();this.select(target);this.tabs[target].focus();
    });
   });
   this.initCarousels();
   this.select(0);
   this.addEventListener('shopify:block:select',event => {
    const index = this.panels.findIndex(panel => panel.contains(event.target) || panel === event.target);
    if (index >= 0) this.select(index);
   });
  }
  disconnectedCallback() { this.carouselObserver?.disconnect(); }
  initCarousels() {
   this.carouselObserver = new ResizeObserver(() => this.updateCarousels());
   this.querySelectorAll('[data-px-product-track]').forEach(track => {
    const panel = track.closest('[data-px-panel]');
    const previous = panel.querySelector('[data-px-carousel-prev]');
    const next = panel.querySelector('[data-px-carousel-next]');
    const move = direction => track.scrollBy({left:direction * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    track.addEventListener('scroll',()=>this.updateCarousels(),{passive:true});
    track.addEventListener('keydown',event=>{
     if(event.target!==track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
     event.preventDefault(); move(event.key==='ArrowLeft'?-1:1);
    });
    this.carouselObserver.observe(track);
   });
  }
  updateCarousels() {
   this.panels.filter(panel=>!panel.hidden).forEach(panel=>{
    const track=panel.querySelector('[data-px-product-track]');
    if(!track) return;
    panel.querySelector('[data-px-carousel-prev]').disabled=track.scrollLeft<=2;
    panel.querySelector('[data-px-carousel-next]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
    panel.querySelector('[data-px-carousel-controls]').hidden=track.scrollWidth<=track.clientWidth+2;
   });
  }
  select(index) {
   this.tabs.forEach((tab,i) => {tab.setAttribute('aria-selected',String(i === index));tab.tabIndex = i === index ? 0 : -1;});
   this.panels.forEach((panel,i) => {panel.hidden = i !== index;});
   requestAnimationFrame(()=>this.updateCarousels());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-seasonal-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('px-daily-essentials'))customElements.define('px-daily-essentials',class extends HTMLElement{
 connectedCallback(){
  this.tabs=[...this.querySelectorAll('[role="tab"]')];
  this.tabList=this.querySelector('[role="tablist"]');
  this.compact=matchMedia('(max-width:820px)');
  this.syncOrientation=()=>this.tabList.setAttribute('aria-orientation',this.compact.matches?'horizontal':'vertical');
  this.compact.addEventListener('change',this.syncOrientation);this.syncOrientation();
  this.tabs.forEach((tab,index)=>{
   tab.addEventListener('click',()=>this.selectTab(index));
   tab.addEventListener('keydown',event=>{
    let next=index;
    if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%this.tabs.length;
    else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index-1+this.tabs.length)%this.tabs.length;
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=this.tabs.length-1;
    else return;
    event.preventDefault();this.selectTab(next);this.tabs[next].focus();
   });
  });
  if(!this.querySelector('[data-px-pool]'))return;
  this.update();
  if(Number(this.dataset.month)!==new Date().getUTCMonth()+1)this.refresh();
  this.timer=setInterval(()=>{if(Math.floor(Date.now()/86400000)!==this.day)this.refresh()},60000);
 }
 disconnectedCallback(){clearInterval(this.timer);this.compact?.removeEventListener('change',this.syncOrientation)}
 selectTab(index){
  if(this.compact.matches){
   const tab=this.tabs[index],list=this.tabList;
   list.scrollTo({left:tab.offsetLeft-list.offsetLeft-(list.clientWidth-tab.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }
  this.tabs.forEach((tab,i)=>{
   const active=i===index;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;
   this.querySelector('[id="'+tab.getAttribute('aria-controls')+'"]').hidden=!active;
  });
 }
 update(){
  const now=new Date();this.day=Math.floor(now.getTime()/86400000);
  this.querySelector('[data-px-month]').textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'long',timeZone:'UTC'}).format(now);
  this.querySelectorAll('[data-px-daily-card]').forEach(card=>{
   const source=card.querySelector('[data-px-pool]');if(!source)return;const pool=JSON.parse(source.textContent);if(!pool.length)return;
   const p=pool[(this.day+Number(card.dataset.offset))%pool.length];
   card.querySelectorAll('[data-px-product-link],[data-px-photo-link]').forEach(a=>a.setAttribute('href',p.url));
   card.querySelector('[data-px-title]').textContent=p.title;card.querySelector('[data-px-price]').textContent=p.price;
   card.querySelectorAll('[data-px-product-link] img,.px-seasonal-catalog-photo').forEach(img=>{img.removeAttribute('srcset');img.src=p.image;img.alt=p.title});
  });
 }
 async refresh(){
  if(this.refreshing)return;this.refreshing=true;
  const selected=this.tabs.findIndex(t=>t.getAttribute('aria-selected')==='true');
  try{
   const url=new URL(location.href);url.searchParams.set('section_id',this.dataset.section);url.searchParams.set('_px_day',String(Math.floor(Date.now()/86400000)));
   const response=await fetch(url);if(!response.ok)throw new Error('Section unavailable');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');const replacement=doc.querySelector('px-daily-essentials');
   if(replacement){this.replaceWith(replacement);replacement.selectTab(Math.max(0,Math.min(selected,replacement.tabs.length-1)))}
  }catch{this.update()}finally{this.refreshing=false}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-shop-bundles"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('px-bundle-slider')){
 customElements.define('px-bundle-slider',class extends HTMLElement{
  connectedCallback(){
   if(this.dataset.ready)return;
   this.dataset.ready='true';
   this.track=this.querySelector('[data-px-bundle-track]');
   this.prev=this.querySelector('[data-px-bundle-prev]');
   this.next=this.querySelector('[data-px-bundle-next]');
   this.position=this.querySelector('[data-px-bundle-position]');
   this.prev.addEventListener('click',()=>this.move(-1));
   this.next.addEventListener('click',()=>this.move(1));
   this.track.addEventListener('scroll',()=>this.update(),{passive:true});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}
   });
   this.observer=new ResizeObserver(()=>this.update());
   this.observer.observe(this.track);
   this.update();
  }
  move(direction){
   this.track.scrollBy({left:direction*(this.track.clientWidth+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  update(){
   const count=this.track.children.length;
   const index=Math.round(this.track.scrollLeft/(this.track.clientWidth+24));
   this.prev.disabled=this.track.scrollLeft<2;
   this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;
   this.position.textContent=(index+1)+' / '+count;
  }
  disconnectedCallback(){this.observer?.disconnect();delete this.dataset.ready;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-shop-profession"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('px-profession-carousel')){
 customElements.define('px-profession-carousel',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const track=this.querySelector('[data-px-profession-track]');
   const move=direction=>{
    const card=track.querySelector('.px-profession-card');
    const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
    track.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   };
   this.querySelector('[data-px-profession-prev]').addEventListener('click',()=>move(-1));
   this.querySelector('[data-px-profession-next]').addEventListener('click',()=>move(1));
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-store-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('px-footer-menus')) {
 customElements.define('px-footer-menus',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.media=matchMedia('(max-width:768px)');
   this.buttons=Array.from(this.querySelectorAll('.px-footer-toggle'));
   this.buttons.forEach(button=>button.addEventListener('click',()=>{
    if(!this.media.matches)return;
    this.setOpen(button,button.getAttribute('aria-expanded')!=='true');
   }));
   this.sync=()=>{
    this.dataset.enhanced='true';
    this.buttons.forEach(button=>{button.disabled=!this.media.matches;this.setOpen(button,!this.media.matches)});
   };
   this.media.addEventListener('change',this.sync);this.sync();
  }
  setOpen(button,open){
   button.setAttribute('aria-expanded',String(open));
   const panel=this.querySelector('#'+CSS.escape(button.getAttribute('aria-controls')));
   panel.inert=!open;panel.classList.toggle('is-open',open);
  }
  disconnectedCallback(){this.media?.removeEventListener('change',this.sync)}
 });
}

  } catch(e) { console.error(e); }
})();
})();
